<template>
	<div>
		<v-row class="mt-3 body-transaction-product body-transaction-product-sm">
			<v-col cols="12" class="pt-0">
				<v-card class="pa-3 elevation-0 rounded-xl hover-shadow" v-if="false">
					<div class="px-3 d-flex">
						<v-icon class="cl-primary">mdi-database-outline</v-icon>
						<div class="pl-1 cl-primary font-size-12 font-weight-bold">Ringkasan Transaksi</div>
					</div>
					<div class="px-3">
						<v-card class="mt-3 pa-3 elevation-1 rounded-lg">
							<div class="d-flex flex-wrap">
								<v-col md="6" class="py-0">
									<div class="cl-dark-green font-size-12">Total Harga</div>
								</v-col>
								<v-col md="6" class="py-0 text-md-right">
									<div class="cl-dark-green font-size-13 font-weight-bold">{{ summaryData.total_price | toRupiah }}</div>
								</v-col>
								<v-col md="6" class="pt-2 pb-0">
									<div class="cl-dark-green font-size-12">Total Berat</div>
								</v-col>
								<v-col md="6" class="pt-2 pb-0 text-md-right">
									<div class="cl-dark-green font-size-13 font-weight-bold">{{ summaryData.total_weight | toKg }}</div>
								</v-col>
							</div>
						</v-card>
						<v-card class="mt-3 pa-3 elevation-1 rounded-lg">
							<div class="d-flex flex-wrap">
								<v-col md="3" class="py-0 my-auto">
									<div class="cl-dark-green font-size-12 font-weight-bold">Jasa Pengiriman</div>
								</v-col>
								<v-col md="5" class="py-0 my-auto">
									<div class="cl-dark-green font-size-12 font-weight-bold">{{ summaryData.expedition_name }}</div>
									<div class="cl-dark-green font-size-12">{{ summaryData.expedition_service }}</div>
									<div class="cl-light-grey font-size-10">Estimasi sampai {{ summaryData.expedition_etd }} hari</div>
								</v-col>
								<v-col md="4" class="py-0 my-auto text-md-right">
									<div class="cl-dark-green font-size-13 font-weight-bold">{{ summaryData.expedition_price | toRupiah }}</div>
								</v-col>
							</div>
						</v-card>
						<v-card class="mt-3 pa-3 elevation-1 rounded-lg">
							<div class="d-flex flex-wrap">
								<v-col md="6" class="py-0">
									<div class="cl-dark-green font-size-14 font-weight-bold">Total Pembayaran</div>
								</v-col>
								<v-col md="6" class="py-0 text-md-right">
									<div class="cl-dark-green font-size-15 font-weight-bold">{{ summaryData.total_payment | toRupiah }}</div>
								</v-col>
							</div>
						</v-card>
					</div>
				</v-card>
				<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
					<div class="d-flex flex-wrap justify-center">
						<v-col cols="6" sm="4" md="3" class="pt-0">
							<v-img src="assets/ilustration/ilustrasi-confirm-transaction.svg"></v-img>
						</v-col>
						<v-col cols="12" class="pb-0 text-center">
							<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-500">Anda berhasil melakukan pembelian produk !!</div>
						</v-col>
					</div>
					<!-- <div class="pt-3 px-3 cl-dark-green font-size-xs-10 font-size-11 text-center">Silakan melakukan pembayaran ke salah satu bank dibawah ini sebesar <span class="font-weight-bold">{{ responseSuccess.transaction_total_price | toRupiah }}</span></div> -->
					<!-- <div class="px-3 pt-1 pb-5">
						<div class="d-flex flex-wrap justify-center">
							<v-col cols="12" sm="4" class="pt-5 pb-0 text-center" v-for="bank in companyBank" :key="bank.bank_company_id">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ bank.bank_company_name }}</div>
								<div>
									<img width="80px" height="80px" class="rounded-xl" :src="bank.bank_company_bank_logo" v-if="bank.bank_company_bank_logo">
									<img width="80px" height="80px" class="rounded-xl" src="assets/image/user-pict.jpg" v-else>
								</div>
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ bank.bank_company_bank_acc_number }}</div>
								<div class="cl-grey font-size-xs-10 font-size-11">an {{ bank.bank_company_bank_acc_name }}</div>
							</v-col>
						</div>
					</div> -->
					<!-- <template v-if="shippingMethod == 'pick-up'">
						<div class="pt-2 cl-dark-green font-size-xs-10 font-size-11 font-weight-bold text-center">Jadwal pick up produk hanya di hari kerja setiap hari senin sampai jumat jam 9.00 - 16.30</div>
						<div class="pt-2 cl-dark-green font-size-xs-10 font-size-11 font-weight-bold text-center">Tempat pick up di Jl. Tanjung Duren Utara X no 10 Jakarta Barat 11470 Indonesia</div>
					</template> -->
					<v-col cols="12" class="pt-5 pb-1 text-center">
						<!-- <v-btn outlined color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" @click="goUploadBukti(responseSuccess.transaction_code)">
							<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Upload Bukti Pembayaran</span>
							<v-icon>mdi-upload-outline</v-icon>
						</v-btn> -->
						<!-- <div class="cl-dark-green font-size-xs-10 font-size-11 py-2">atau</div> -->
						<v-btn depressed color="primary" height="45" class="white--text rounded-xl text-capitalize font-weight-bold" @click="reloadPage">
							<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Beli Produk Lagi</span>
							<v-icon>mdi-cart-outline</v-icon>
						</v-btn>
					</v-col>

					<v-col cols="12" class="pt-5 pb-1 text-center">
						<v-btn text dense color="primary" class="primary--text font-weight-bold" @click="toOrderReport">
							<v-icon>mdi-arrow-left</v-icon>
							<span class="pl-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Lihat laporan belanja produk</span>
						</v-btn>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			params: {},
		}
	},
	props: {
		summaryData: Object,
		shippingMethod: String,
	},
	computed: {
		...mapState('option', ['companyBank']),
		...mapState('transactionProduct', ['responseSuccess']),

	},
	methods: {
		...mapActions('option', ['getCompanyBank']),

		getData() {
			this.getCompanyBank()
		},
		goUploadBukti(code) {
			this.$router.push({ name: 'detail-upload-bukti', params: {type: 'upload', slug: code} })
		},
		reloadPage() {
			this.$router.go(this.$router.currentRoute)
		},
		toOrderReport() {
			this.$router.push({ path: 'lap-belanja-produk'})
		}
	},
	created() {
	},
};
</script>